/**
 * Telescope configuration dialog for editing telescope/camera settings.
 */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const TelescopeConfigDialog = ({
  open,
  onClose,
  telescopeConfig,
  setTelescopeConfig,
  onSave,
}) => {
  const updateConfig = (field, value) => {
    setTelescopeConfig({ ...telescopeConfig, [field]: value });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Telescope Configuration</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Aperture (mm)"
              value={telescopeConfig.telescopeAperture}
              onChange={(e) => updateConfig('telescopeAperture', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Focal Length (mm)"
              value={telescopeConfig.focalLength}
              onChange={(e) => updateConfig('focalLength', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Pixel Size (um)"
              value={telescopeConfig.cameraPixelSize}
              onChange={(e) => updateConfig('cameraPixelSize', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Readout Time (s)"
              value={telescopeConfig.readoutTime}
              onChange={(e) => updateConfig('readoutTime', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Min Exposure (s)"
              value={telescopeConfig.minExposure}
              onChange={(e) => updateConfig('minExposure', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Max Exposure (s)"
              value={telescopeConfig.maxExposure}
              onChange={(e) => updateConfig('maxExposure', parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Default Exposure (s)"
              value={telescopeConfig.defaultExposure}
              onChange={(e) => updateConfig('defaultExposure', parseFloat(e.target.value))}
              helperText="Exposure time to use for observations"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Filter</InputLabel>
              <Select
                value={telescopeConfig.selectedFilter}
                onChange={(e) => updateConfig('selectedFilter', e.target.value)}
                label="Filter"
              >
                {telescopeConfig.filters.map((filter) => (
                  <MenuItem key={filter} value={filter}>
                    {filter}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Binning</InputLabel>
              <Select
                value={telescopeConfig.binning}
                onChange={(e) => updateConfig('binning', parseInt(e.target.value))}
                label="Binning"
              >
                <MenuItem value={1}>1x1</MenuItem>
                <MenuItem value={2}>2x2</MenuItem>
                <MenuItem value={3}>3x3</MenuItem>
                <MenuItem value={4}>4x4</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained" color="primary">
          Save Configuration
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TelescopeConfigDialog;
